/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// GET /api/v1/admin/cloud-connected/clusters
// ts-unused-exports:disable-next-line
export const listClusters = async (args?: {
  queryParameters?: operations['adminListClusters']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ClusterList']>(
    applyParameters('/api/v1/admin/cloud-connected/clusters', args),
    {
      method: 'GET',
    },
  )

// DELETE /api/v1/admin/cloud-connected/clusters
// ts-unused-exports:disable-next-line
export const deleteOrganizationClusters = async <
  T = operations['adminDeleteOrganizationClusters']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminDeleteOrganizationClusters']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  queryParameters: operations['adminDeleteOrganizationClusters']['parameters']['query']
  body: Exact<
    T,
    operations['adminDeleteOrganizationClusters']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminDeleteOrganizationClusters']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/cloud-connected/clusters', args), {
    method: 'DELETE',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/admin/cloud-connected/clusters/_disable-paid-services
// ts-unused-exports:disable-next-line
export const disableOrganizationPaidServices = async <
  T = operations['adminDisableOrganizationPaidServices']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminDisableOrganizationPaidServices']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  queryParameters: operations['adminDisableOrganizationPaidServices']['parameters']['query']
  body: Exact<
    T,
    operations['adminDisableOrganizationPaidServices']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminDisableOrganizationPaidServices']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/cloud-connected/clusters/_disable-paid-services', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/admin/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const getCluster = async (args: {
  pathParameters: operations['adminGetCluster']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Cluster']>(
    applyParameters('/api/v1/admin/cloud-connected/clusters/{id}', args),
    {
      method: 'GET',
    },
  )

// DELETE /api/v1/admin/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const deleteCluster = async (args: {
  pathParameters: operations['adminDeleteCluster']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/cloud-connected/clusters/{id}', args), {
    method: 'DELETE',
  })

// PATCH /api/v1/admin/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const patchCluster = async <
  T = operations['adminPatchCluster']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminPatchCluster']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['adminPatchCluster']['parameters']['path']
  queryParameters?: operations['adminPatchCluster']['parameters']['query']
  body: Exact<
    T,
    operations['adminPatchCluster']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminPatchCluster']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['Cluster']>(
    applyParameters('/api/v1/admin/cloud-connected/clusters/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )
